import { useEffect } from 'react';
import { useAuthStore } from '@/auth/authStore';

export function AuthProvider({ children }) {
  const loadAuth = useAuthStore((s) => s.loadAuth);
  const loading = useAuthStore((s) => s.loading);

  useEffect(() => {
    loadAuth();
  }, [loadAuth]);

  return children;
}
